export const promotionRocket = 'https://static.tickchak.co.il/images/app/promotion/promotionRocket.png';
export const promotionRocketMobile = 'https://static.tickchak.co.il/images/app/promotion/promotionRocketMobile.png';
